"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section ref={ref} className="relative min-h-[60vh] flex items-center justify-center overflow-hidden bg-background py-24">
      {}
      <div className="absolute inset-0 opacity-5 bg-repeat bg-[length:200px_200px]" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Cellipse cx='100' cy='100' rx='25' ry='40' fill='%23000' opacity='0.1'/%3E%3C/svg%3E")`,
      animation: "scroll-texture 60s linear infinite"
    }} />

      {}
      <div className={`relative z-10 max-w-3xl mx-auto px-6 py-16 rounded-lg bg-dark-background/60 backdrop-blur-sm shadow-strong border border-border/20 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
        {}
        <h2 className={`text-4xl md:text-5xl font-display font-bold text-foreground-dark text-center mb-6 transition-all duration-[var(--duration-medium)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          Discover Canada's Finest Coffee
        </h2>

        {}
        <p className={`text-lg text-foreground-dark/80 text-center mb-10 max-w-2xl mx-auto transition-all duration-[var(--duration-medium)] delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          Explore our curated selection of specialty coffee roasters, rated by
          coffee enthusiasts across the nation. Start your journey to exceptional
          coffee today.
        </p>

        {}
        <div className={`flex justify-center transition-all duration-[var(--duration-medium)] delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Link to="/RoastersPage">
            <Button size="lg" className="relative overflow-hidden group btn-primary text-lg px-8 py-4 animate-pulse-subtle hover:animate-none focus-ring">
              <span className="relative z-10">Explore Top Roasters</span>
              {}
              <span className="absolute inset-0 bg-primary-hover opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" />
              <span className="absolute inset-0 scale-0 group-active:scale-150 bg-primary-light/30 rounded-full transition-transform duration-500 ease-[var(--ease-out-back)]" />
            </Button>
          </Link>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll-texture {
          0% {
            background-position: 0 0;
          }
          100% {
            background-position: 0 200px;
          }
        }

        @keyframes pulse-subtle {
          0%, 100% {
            box-shadow: 0 0 0 0 hsla(35, 70%, 45%, 0.4);
          }
          50% {
            box-shadow: 0 0 0 8px hsla(35, 70%, 45%, 0);
          }
        }

        .animate-pulse-subtle {
          animation: pulse-subtle 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
      `}</style>
    </section>;
}